<template>
  <v-main>
    <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
    <v-container fluid>
      <v-card>
        <v-card-title> Hubungi Kami </v-card-title>
        <v-fab-transition>
          <v-btn
            v-if="isEditable == 0"
            class="mt-8 mr-4"
            color="pink"
            dark
            absolute
            top
            right
            fab
            @click="changeEditable"
          >
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
        </v-fab-transition>
        <v-form
          ref="form"
          v-model="valid"
          lazy-validation
          class="pl-4 pr-4 pt-4"
        >
          <v-row dense>
            <v-col cols="12">
              <v-row dense>
                <v-col cols="12" sm="12" md="12">
                  <v-textarea
                    v-model="dataRs.deskripsi"
                    label="Hubungi Kami"
                    rows="12"
                    row-height="15"
                    outlined
                    dense
                    :readonly="isEditable == 0"
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" class="d-flex justify-end">
              <v-btn
                v-if="isEditable == 1"
                style="margin-right: 10px"
                @click="doBatal"
                >Batal</v-btn
              >
              <v-btn
                v-if="isEditable == 1"
                dark
                color="primary"
                type="button"
                @click="doSubmit"
                >Simpan</v-btn
              >
            </v-col>
          </v-row>
        </v-form>
      </v-card>
    </v-container>
  </v-main>
</template>

<script>
import HubungiKamiService from "../../services/HubungiKamiService";
import CommonService from "../../services/CommonService";

export default {
  name: "HubungiKami",
  components: {},
  data: () => ({
    isEditable: 0,
    breadcrumbs: [
      {
        text: "Web Content",
        disabled: false,
        exact: true,
        to: { name: "/webcontent/hubungi-kami" },
      },
      { text: "Hubungi Kami", disabled: true },
    ],
    valid: true,
    dataRs: {
      deskripsi: "",
    },
    id: null,
  }),
  mounted: async function () {
    this.getHubungiKami();
  },
  methods: {
    changeEditable: function () {
      this.isEditable = 1;
    },

    async getHubungiKami() {
      HubungiKamiService.getHubungiKami()
        .then((res) => {
          if (res.data.data) {
            this.dataRs = res.data.data;
            this.id = res.data.data.id;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    doBatal: function () {
      this.isEditable = 0;
      this.getHubungiKami();
    },

    doSubmit: async function () {
      if (!this.$refs.form.validate()) {
        window.scrollTo(0, 0);
        return;
      }

      HubungiKamiService.update(this.dataRs, this.id)
        .then(() => {
          this.isEditable = 0;

          CommonService.showSuccessToast("Update Data berhasil");

          this.getHubungiKami();
        })
        .catch((err) => {
          console.log(err);
          CommonService.showErrorToast("Update data gagal. Coba lagi");
        });
    },
  },
};
</script>

<style scoped></style>
